import { useEffect } from 'react';
import ResizableField from '../utility/resizableField';

// Width-only resizing, for the fields that have no height of their own to drag:
// the ones drawn without an input box (Submitters info auto entry, the checkbox
// list), whose height follows their content, and the Address group, whose rows
// are laid out by its grid. `ResizableField` leaves the row-resize handle out
// when the height handlers are missing, so none of them get one by mistake.
//
// For the boxed fields the handle is injected next to the field and then pinned
// to the edge of the box that outlines it — see `.is-resize-boxed` in
// form-builder/layout.scss.
export const useWidthResizableField = (fieldRef, element, setPosition) => {
  useEffect(() => {
    if (!fieldRef.current || !setPosition) return;

    const handlerWidthChange = (shift) => {
      const formArea = document.getElementsByClassName('form-area')[0];

      if (!formArea?.offsetWidth) return;

      const formAreaWidth = formArea.offsetWidth;

      setPosition((prevPosition) => ({
        ...prevPosition,
        width: Math.max(
          5,
          Math.min(100 - prevPosition.left, Math.floor((((prevPosition.startWidth / 100) * formAreaWidth + shift) / formAreaWidth) * 100)),
        ),
      }));
    };

    const finishWidthChange = () => {
      setPosition((prevPosition) => ({ ...prevPosition, startWidth: prevPosition.width }));
    };

    ResizableField(fieldRef.current, handlerWidthChange, finishWidthChange);
  }, [fieldRef, element, element.options.width, setPosition]);
};

export default useWidthResizableField;
